module.exports = __webpack_public_path__ + "static/media/Bloomberg_Logo.3ee92577.jpg";